import { Card } from '@/components/ui/card';
import { Clock, MessageSquare, Calculator, FileText } from 'lucide-react';
import { format } from 'date-fns';

interface ClientTimelineProps {
  client: any;
  timeline?: any[];
  calculations?: any[];
  documents?: any[];
}

export const ClientTimeline = ({ client, timeline = [], calculations = [], documents = [] }: ClientTimelineProps) => {
  return (
    <Card className="p-6 bg-[#222222] border-white/10">
      <div className="space-y-4">
        <div className="flex items-center gap-2 border-l-2 border-primary pl-4">
          <Clock className="h-4 w-4 text-primary" />
          <div>
            <p className="text-white">Client Created</p>
            <p className="text-sm text-gray-400">
              {format(new Date(client.created_at), 'PPP')}
            </p>
          </div>
        </div>
        
        <div className="flex items-center gap-2 border-l-2 border-primary pl-4">
          <MessageSquare className="h-4 w-4 text-primary" />
          <div>
            <p className="text-white">Last Contact</p>
            <p className="text-sm text-gray-400">
              {format(new Date(client.last_contact), 'PPP')}
            </p>
          </div>
        </div>

        {calculations?.map((calc) => (
          <div key={calc.id} className="flex items-center gap-2 border-l-2 border-primary pl-4">
            <Calculator className="h-4 w-4 text-primary" />
            <div>
              <p className="text-white">Calculation Performed</p>
              <p className="text-sm text-gray-400">
                {format(new Date(calc.created_at || ''), 'PPP')}
              </p>
            </div>
          </div>
        ))}

        {documents?.map((doc) => (
          <div key={doc.id} className="flex items-center gap-2 border-l-2 border-primary pl-4">
            <FileText className="h-4 w-4 text-primary" />
            <div>
              <p className="text-white">Document Uploaded: {doc.name}</p>
              <p className="text-sm text-gray-400">
                {format(new Date(doc.created_at), 'PPP')}
              </p>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};